module.exports = __webpack_public_path__ + "front/img/d7.3aae8304.png";